// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PricingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Effective pricing row response — Full-gated GET ai/credits/pricing.
 *
 * Returns the rate row that would be used for a settle at this moment:
 * override row for the franchise if present, else the global row.
 * Includes all rate columns plus the is_override flag so the caller knows
 * which source the row came from.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PricingResponseDados {
id: number
model_name: string
cache_hit_usd_per_1m: string
cache_miss_usd_per_1m: string
output_usd_per_1m: string
valid_from: string
is_override: boolean
valid_to?: string
franquia_id?: number
}

export type AiCredits_PricingResponse = ApiResponse<AiCredits_PricingResponseDados>;

registerResponseContract('AiCredits_PricingResponse', {
  id:                    { type: 'number',  required: true },
  model_name:            { type: 'string',  required: true },
  cache_hit_usd_per_1m:  { type: 'string',  required: true },
  cache_miss_usd_per_1m: { type: 'string',  required: true },
  output_usd_per_1m:     { type: 'string',  required: true },
  valid_from:            { type: 'string',  required: true },
  is_override:           { type: 'boolean', required: true },
  valid_to:              { type: 'string',  required: false },
  franquia_id:           { type: 'number',  required: false },
})
